module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: _vm.wrapClasses,
    attrs: {
      "disabled": _vm.disabled,
      "checked": _vm.currentValue
    }
  }, [_c('input', {
    class: _vm.inputClasses,
    attrs: {
      "type": "radio",
      "disabled": _vm.disabled,
      "name": _vm.groupName
    },
    domProps: {
      "checked": _vm.currentValue
    },
    on: {
      "change": _vm._change
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.innerClasses
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.label))])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d906ac3c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/radio/radio.vue
// module id = 411
// module chunks = 0